import PortalAppService from "../../../application/platform/portal-app-service";
import { IListUsefulLinksRequest } from "../../../model/base/request/list-useful-links-request";
import { useUsefulLinksDispatch } from "./useful-links-context";
import { ACTION_TYPES } from "./useful-links-reducer";

export const useUsefulLinksController = () => {
    const dispatch = useUsefulLinksDispatch();

    const loadData = async (request: IListUsefulLinksRequest) => {
        const response = await PortalAppService.requestUsefulLinks(request);
        dispatch({ type: ACTION_TYPES.SET_USEFUL_LINKS, payload: response });
    };

    const loadLinkCategories = async () => {
        const response = await PortalAppService.requestLinkCategories();
        dispatch({ type: ACTION_TYPES.SET_LINK_CATEGORIES, payload: response });
    };

    return {
        loadData,
        loadLinkCategories
    };
};
